module.exports = __webpack_public_path__ + "media/images/logos/amazon_logo-c84cfc3c229e0f1704afc8081f8731dc.png";